import { PresignedPost } from '../types/PresignedUpload.type';

/**
 * Uploads a file to S3 using a presigned POST.
 *
 * @returns The S3 object key (`fields.key`) to send back to the API as
 *   `file_path` / `attachment_path`.
 */
export async function uploadToPresignedPost(post: PresignedPost, file: File): Promise<string> {
  const formData = new FormData();

  Object.entries(post.fields).forEach(([key, value]) => {
    formData.append(key, value);
  });

  // The file field must be appended last for S3 to accept the upload.
  formData.append('file', file);

  const response = await fetch(post.url, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`File upload failed with status ${response.status}.`);
  }

  return post.fields.key;
}
